<!-- TEMPLATE -->
<template>
  <div class="main-page" :class="{loading: $store.getters.getLoadOverlay}">
    <header-menu
            key="header"
            id="main-header"
            :logo="getLogo()"
            logo-height="40"
            @mobile-menu-state="mobileMenuState">
    </header-menu>
    <router-view
            id="main-content"
            key="xxxxxx">
    </router-view>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  // VUE
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';

  import { FadeTransition, ZoomYTransition } from 'vue2-transitions';

  import {
    // COMPONENTS
    deanIcon,
    deanOneviewLogo,
    goBg, X,
  } from '@deanone/dean-components';

  import HeaderMenu from './header.vue';

  @Component({
    components: {
      HeaderMenu,
      deanIcon,
      deanOneviewLogo,
      goBg,
      FadeTransition,
      ZoomYTransition,
    },
  })

  export default class MainPage extends Vue {
    // PROPS
    @Prop()
    public data!: object;

    // DATA
    // Normally Session validated value should come out of the api call below and set standard to false
    public noScroll: boolean = false;

    public appBg: object = goBg;

    public getLogo() {
      return deanOneviewLogo;
    }

    // COMPUTED
    get mainContainerClass() {
      let value = 'main-page';
      if (this.noScroll) {
        value += ` no-scroll-container`;
      }
      return value;
    }

    // METHODS
    public mobileMenuState(state: boolean) {
      this.noScroll = state;
      this.$emit('mobile-menu-state', state);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import "~@deanone/dean-components/src/scss/vars";

.main-page {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  transition: background-color 0.3s;

  :deep(.dean-header-menu) {
    position: static;
  }

  :deep(.items-per-page) label {
    margin-right: 10px;
  }

  &.loading{
    background-color: $color-dark;
  }

  .spacing {
    display: block;
    width: 100%;
    height: 80px;
  }

  .bg-logo {
    position: fixed;
    @include calc('top', "50% - 500px");
    @include calc('right', "50% - 500px");
    height: 1000px;
    fill: var(--color-light-shade-2, $color-light-shade-2);
  }

  @media #{$medium-only} {
    .bg-logo {
      @include calc('top', "50% - 250px");
      @include calc('right', "50% - 250px");
      height: 500px;
    }
  }
  @media #{$small-only} {
    .bg-logo {
      @include calc('right', "50% - 160px");
      width: 320px;
    }
  }
}
</style>
